import { z } from 'zod';
import { workspaceUserSchema } from './collaboration';

export const projectSchema = z
  .object({
    id: z.number(),
    name: z.string(),
    description: z.string().nullish(),
    created_at: z.string().datetime(),
    created_by: z.union([z.string(), workspaceUserSchema]),
    updated_at: z.string().datetime(),
    updated_by: z.string(),
    project_id: z.string().uuid().nullish(), // TODO: remove nullish once backend is updated
  })
  .transform((data) => {
    const id = data.project_id ?? data.id.toString();
    const { project_id: _, ...rest } = data;

    return {
      ...rest,
      id,
    };
  });
export type Project = z.infer<typeof projectSchema>;

export const projectsSchema = z.array(projectSchema);
export type Projects = z.infer<typeof projectsSchema>;

export const projectResponseSchema = z.union([z.string().uuid(), z.number()]).transform(String);
export type ProjectResponse = z.infer<typeof projectResponseSchema>;
